import { useTranslation } from 'react-i18next'
import { VotePreviewCard } from './VotePreviewCard'

// Matches the prototype's `.not-subscribed-state` treatment reused for a
// feature that doesn't exist yet at all (Monthly Limits / Tenant Limits),
// rather than a product that simply isn't contracted — same badge/vote-pair
// shell as NotContractedPreview (see VotePreviewCard), but a "Not available
// yet" pill instead of "Contact us" and no product prop (these pages aren't
// per-product).
export function ComingSoonPreview({
  title,
  description,
  feature,
}: Readonly<{
  title: string
  description: string
  /** The vote's analytics key (lib/previewVoteFeature.ts `COMING_SOON_VOTE_FEATURE`). */
  feature: string
}>) {
  const { t } = useTranslation()
  return (
    <VotePreviewCard
      badgeText={t('common.previewBadge')}
      title={title}
      description={description}
      pillText={t('previewPage.notAvailable')}
      feature={feature}
      featureName={title}
    />
  )
}
